
import React from 'react';
import { Check } from 'lucide-react';
import { ServiceData } from '@/types/serviceTypes';

interface ServiceDescriptionProps {
  service: ServiceData;
}

const ServiceDescription = ({ service }: ServiceDescriptionProps) => {
  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-serif font-bold mb-8 text-pkstone-900">
            About Our {service.title} Service
          </h2>
          
          <div className="prose prose-lg max-w-none text-pkstone-700 mb-12">
            {service.longDescription?.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16">
            {/* Features */}
            <div>
              <h3 className="text-2xl font-serif font-bold mb-6 text-pkstone-900">
                Service Features
              </h3>
              <ul className="space-y-3">
                {service.features.map((feature, index) => (
                  <li key={index} className="flex items-start">
                    <Check className="h-5 w-5 text-pkgreen-500 mr-3 flex-shrink-0 mt-1" />
                    <span className="text-pkstone-700">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
            
            {/* Benefits */}
            {service.benefits && (
              <div>
                <h3 className="text-2xl font-serif font-bold mb-6 text-pkstone-900">
                  Benefits
                </h3>
                <ul className="space-y-3">
                  {service.benefits.map((benefit, index) => (
                    <li key={index} className="flex items-start">
                      <Check className="h-5 w-5 text-pkgreen-500 mr-3 flex-shrink-0 mt-1" />
                      <span className="text-pkstone-700">{benefit}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceDescription;
